import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setCredentials } from "../slices/authSlice"; // adjust path as needed

const AppInRoute = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const usertoken = searchParams.get("usertoken"); // keep same param name you used
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const verifyTable = async () => {
      localStorage.setItem("apptype", "app");

      if (!usertoken) {
        // toast.error("Invalid user token");
        // navigate("/");
        navigate("/");
        return;
      }

      try {
        const res = await axios.get(`${window.BASE_API_URL}verifyUser/${usertoken}`);

        if (res.data?.success) {
          // Example: res.data.data should contain user info and token.
          // Adapt mapping below if your API wraps fields differently.
          const returned = res.data?.data || {};

          // Preserve settings before clearing (as you hinted in your original code)
          const settings = localStorage.getItem("settings");

          // Map fields returned from verifyUser to your user object shape:
          // adjust these keys if your API uses different names
          const user = {
            id: returned.id ?? returned.user_id ?? null,
            name: returned.name ?? returned.user_name ?? returned.full_name ?? "",
            email: returned.email ?? returned.user_email ?? "",
            phone: returned.phone ?? returned.mobile ?? "",
            // store token in same place as your login flow expects
            token: returned.token ?? res.data.token ?? returned.access_token ?? null,
          };

          if (!user.token) {
            // If token not present: you may still treat verify as sessionless. Handle accordingly.
            console.warn("No token returned by verifyUser; continuing without token");
          }

          // Save token + user in localStorage and set default header
          if (user.token) {
            localStorage.setItem("token", user.token);
            axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
          }
          localStorage.setItem("user", JSON.stringify(user));

          // Restore preserved settings (if you want to reapply)
          if (settings) {
            localStorage.setItem("settings", settings);
          }

          // Dispatch to redux so the app state knows user is logged in
          dispatch(setCredentials({ user, token: user.token }));

          // Finally navigate to the app/menu where you want logged-in users to land
          navigate("/");
        } else {
          toast.error(res.data?.message || "Invalid or inactive user");
          // setTimeout(() => {
          //   window.location.href = "/menu-app";
          // }, 1000);
        }
      } catch (error) {
        console.error("verifyUser error:", error);
        toast.error("Failed to verify user");
        setTimeout(() => {
           navigate("/");
        }, 1000);
      }
    };

    
    verifyTable();
  }, [usertoken, navigate, dispatch]);

  return (
    <div className="flex items-center justify-center h-screen text-lg font-medium">
      Verifying your user...
    </div>
  );
};

export default AppInRoute;
